import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-ice-dark border-t border-gold/20" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row items-center gap-8 bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-gold/10" data-id="element-87">
          <div className="flex-shrink-0 relative" data-id="element-88">
            <div className="absolute inset-0 bg-gold/20 blur-xl rounded-full" data-id="element-89" />
            <div className="w-24 h-24 bg-gradient-to-br from-gold-light to-gold-dark rounded-full flex items-center justify-center relative z-10 shadow-lg border-4 border-white" data-id="element-90">
              <CheckCircle className="w-12 h-12 text-white" data-id="element-91" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-92">
            <h2 className="font-heading text-3xl font-bold text-blue mb-4" data-id="element-93">
              Garantía de Paz Mental (30 Días)
            </h2>
            <p className="font-body text-lg text-navy/80 leading-relaxed" data-id="element-94">
              Si no sientes una diferencia real en tu vida, una mayor
              tranquilidad y paz en tu hogar después de 30 días de usar el
              Escudo de Fe, te devolvemos el 100% de tu dinero.{' '}
              <strong className="text-navy" data-id="element-95">
                Así de seguros estamos de su efectividad.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}